import ROUTES from "./utilities/Routes";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

/**
 * Paginas para formulario de Audi Nuevo
 */
import AudiNuevoForm from "./pages/AudiSite/AudiNuevo/FormularioAudiNuevo";
import AudiNuevoThankYou from "./pages/AudiSite/AudiNuevo/ThankYou";
import AudiNuevoNotFound from "./pages/AudiSite/AudiNuevo/NotFound";

/**
 * Paginas para formulario de Citas de Servicio
 */
import CitasServicioAgendarCita from "./pages/Audicenter/CitasServicio/AgendarCita";
import CitasServicioCancelarCita from "./pages/Audicenter/CitasServicio/CancelarCita";
import CitasServicioThankYou from "./pages/Audicenter/CitasServicio/ThankYou";

/**
 * Paginas para formulario configurador
 */
import AudiConfiguradorBtn from "./pages/AudiSite/Configurador/BotonToFormulario";
import AudiConfigurador from "./pages/AudiSite/Configurador/FormularioConfigurador";
import AudiConfiguradorThankYou from "./pages/AudiSite/Configurador/ThankYou";

/**
 * Paginas para formulario compramos tu auto
 */
import AudiCompramosTuAuto from "./pages/Audicenter/CompramosTuAuto/Formulario";
import AudiCompramosTuAutoThankYou from "./pages/Audicenter/CompramosTuAuto/ThankYou";

/**
 * Paginas para formulario de la campaña Ducatti
 */
import FormCampaignDucatti from "./pages/AudiSite/Campaign/Ducatti/FormularioDucatti";
import FormCampaignDucattiThankYou from "./pages/AudiSite/Campaign/Ducatti/ThankYou";

/**
 * Paginas para formulario de VTP Nuevos / Usados
 */
import VTPNuevosForm from "./pages/AudiSite/VTP/FormularioVTPNuevos";
import VTPNuevosThankYou from "./pages/AudiSite/VTP/ThankYouVTPNuevos";
import VTPUsadosForm from "./pages/AudiSite/VTP/FormularioVTPUsados";
import VTPUsadosThankYou from "./pages/AudiSite/VTP/ThankYouVTPUsados";

/**
 * Paginas para formulario de la campaña Ducatti
 */
import AudiPruebaDeManejo from "./pages/Audicenter/PruebaDeManejo/Formulario";
import AudiPruebaDeManejoThankYou from "./pages/Audicenter/PruebaDeManejo/ThankYou";

/**
 * Paginas para formulario de contacto
 */
import FormularioQuejas from "./pages/AudiSite/Contacto/FormularioQuejas";
import FormularioSugerencias from "./pages/AudiSite/Contacto/FormularioSugerencias";
import FormularioInformacion from "./pages/AudiSite/Contacto/FormularioInformacion";
import FormularioRH from "./pages/AudiSite/Contacto/FormularioRH";
import FormularioOtros from "./pages/AudiSite/Contacto/FormularioOtros";
import FormularioPostventa from "./pages/AudiSite/Contacto/FormularioPostventa";
import FormularioContactoThankYou from "./pages/AudiSite/Contacto/ThankYou";

/**
 * Paginas para formulario de accesorios / collection
 */
import FormularioAccesorios from "./pages/AudiSite/Accesorios/Formulario";
import FormularioAccesoriosThankyou from "./pages/AudiSite/Accesorios/ThankYou";

/**
 * Ruta no reconocida
 */
import NotFound from "./pages/NotFound";

//Redux
import { Provider } from "react-redux";
import store from "./store";
import GeneralTemplate from "./components/layout/GeneralTemplate";

function App() {
  return (
    <Router>
      <Provider store={store}>
        <Routes>

          <Route path={ROUTES.AUDINUEVOGENERAL} element={<GeneralTemplate enableChat enableFloatingMenu enableLegales />}>
            <Route index element={<AudiNuevoForm />} />
            <Route path={ROUTES.AUDINUEVOMODELO} element={<AudiNuevoForm />} />
            <Route path={ROUTES.AUDINUEVOMODELOPREVENTALEALTAD} element={<AudiNuevoForm />} />
            <Route path={ROUTES.AUDINUEVOMODELOPREVENTACONQUISTA} element={<AudiNuevoForm />} />
            <Route path={ROUTES.AUDINUEVOTHANKYOUEMPTY} element={<AudiNuevoThankYou />} />
            <Route path={ROUTES.AUDINUEVOTHANKYOU} element={<AudiNuevoThankYou />} />
            <Route path={ROUTES.AUDINUEVOTHANKYOULEALTAD} element={<AudiNuevoThankYou />} />
            <Route path={ROUTES.AUDINUEVOTHANKYOUCONQUISTA} element={<AudiNuevoThankYou />} />
            <Route path={ROUTES.AUDINUEVOFORMNOTFOUND} element={<AudiNuevoNotFound />} />
          </Route>

          <Route path={ROUTES.AUDICONFIGURADORBTN} element={<AudiConfiguradorBtn />} />
          <Route path={ROUTES.CONFIGURADORGENERAL} element={<GeneralTemplate enableFloatingMenu enableChat />}>
            <Route path={ROUTES.AUDICONFIGURADOR} element={<AudiConfigurador />} />
            <Route path={ROUTES.AUDICONFIGURADORTHANKYOU} element={<AudiConfiguradorThankYou />} />
          </Route>

          <Route path={ROUTES.CITASSERVICIO} element={<CitasServicioAgendarCita />} />
          <Route path={ROUTES.CITASSERVICIOEMPTY} element={<CitasServicioAgendarCita />} />
          <Route path={ROUTES.CITASSERVICIOCANCELARCITA} element={<CitasServicioCancelarCita />} />
          <Route path={ROUTES.CITASSERVICIOTHANKYOUEMPTY} element={<CitasServicioThankYou />} />
          <Route path={ROUTES.CITASSERVICIOTHANKYOU} element={<CitasServicioThankYou />} />

          <Route path={ROUTES.COMPRAMOSTUAUTO} element={<AudiCompramosTuAuto />} />
          <Route path={ROUTES.COMPRAMOSTUAUTOEMPTY} element={<AudiCompramosTuAuto />} />
          <Route path={ROUTES.COMPRAMOSTUAUTOTHANKYOUEMPTY} element={<AudiCompramosTuAutoThankYou />} />
          <Route path={ROUTES.COMPRAMOSTUAUTOTHANKYOU} element={<AudiCompramosTuAutoThankYou />} />

          <Route path={ROUTES.PRUEBADEMANEJO} element={<AudiPruebaDeManejo />} />
          <Route path={ROUTES.PRUEBADEMANEJOEMPTY} element={<AudiPruebaDeManejo />} />
          <Route path={ROUTES.PRUEBADEMANEJOTHANKYOU} element={<AudiPruebaDeManejoThankYou />} />
          <Route path={ROUTES.PRUEBADEMANEJOTHANKYOUEMPTY} element={<AudiPruebaDeManejoThankYou />} />

          <Route path={ROUTES.CAMPAIGNDUCATI} element={<GeneralTemplate enableChat enableFloatingMenu />}>
            <Route index element={<FormCampaignDucatti />} />
            <Route path={ROUTES.CAMPAIGNDUCATITHANKYOUEMPTY} element={<FormCampaignDucattiThankYou />} />
          </Route>

          <Route path={ROUTES.VTPNUEVOS} element={<GeneralTemplate enableChat enableFloatingMenu />}>
            <Route path={ROUTES.VTPNUEVOSVINID} element={<VTPNuevosForm />} />
            <Route path={ROUTES.VTPNUEVOSTHANKYOU} element={<VTPNuevosThankYou />} />
          </Route>

          <Route path={ROUTES.VTPUSADOS} element={<GeneralTemplate enableChat enableFloatingMenu />}>
            <Route path={ROUTES.VTPUSADOSCARID} element={<VTPUsadosForm />} />
            <Route path={ROUTES.VTPUSADOSTHANKYOU} element={<VTPUsadosThankYou />} />
          </Route>

          <Route path={ROUTES.CONTACTOQUEJAS} element={<FormularioQuejas />} />
          <Route path={ROUTES.CONTACTOSUGERENCIA} element={<FormularioSugerencias />} />
          <Route path={ROUTES.CONTACTOSUGERENCIATHANKYOU} element={<FormularioContactoThankYou />} />
          <Route path={ROUTES.CONTACTOINFORMACION} element={<FormularioInformacion />} />
          <Route path={ROUTES.CONTACTOINFORMACIONTHANKYOU} element={<FormularioContactoThankYou />} />
          <Route path={ROUTES.CONTACTORH} element={<FormularioRH />} />
          <Route path={ROUTES.CONTACTORHTHANKYOU} element={<FormularioContactoThankYou />} />
          <Route path={ROUTES.CONTACTOQUEJASTHANKYOU} element={<FormularioContactoThankYou />} />
          <Route path={ROUTES.CONTACTOOTRO} element={<FormularioOtros />} />
          <Route path={ROUTES.CONTACTOOTROTHANKYOU} element={<FormularioContactoThankYou />} />
          <Route path={ROUTES.CONTACTOPOSTVENTA} element={<FormularioPostventa />} />
          <Route path={ROUTES.CONTACTOPOSTVENTATHANKYOU} element={<FormularioContactoThankYou />} />

          <Route path={ROUTES.ACCESORIOSGENERAL} element={<GeneralTemplate />}>
            <Route path={ROUTES.ACCESORIOSFLIPBOOK} element={<FormularioAccesorios />} />
            <Route path={ROUTES.ACCESORIOS} element={<FormularioAccesorios />} />
            <Route path={ROUTES.ACCESORIOSTHANKYOU} element={<FormularioAccesoriosThankyou />} />
            <Route path={ROUTES.ACCESORIOSFLIPTHANKYOU} element={<FormularioAccesoriosThankyou />} />
          </Route>
          <Route path={ROUTES.COLLECTIONGENERAL} element={<GeneralTemplate />}>
            <Route path={ROUTES.COLLECTIONFLIPBOOK} element={<FormularioAccesorios />} />
            <Route path={ROUTES.COLLECTION} element={<FormularioAccesorios />} />
            <Route path={ROUTES.COLLECTIONTHANKYOU} element={<FormularioAccesoriosThankyou />} />
            <Route path={ROUTES.COLLECTIONFLIPTHANKYOU} element={<FormularioAccesoriosThankyou />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Provider>
    </Router>
  );
}

export default App;